$(document).ready(function () {
  var swiper = new Swiper(".mySwiper_top", {
    centeredSlides: true,
    speed:1000,
    autoplay: {
      delay: 4500,
      disableOnInteraction: false,
    },
    loop:true,
    pagination: {
      el: ".swiper-pagination",
    },
  });

  var swiper = new Swiper(".mySwiper_pick_up", {
    mousewheel: {
      forceToAxis:true
    },
//     loop: true,
    speed:600,
    spaceBetween: 28,
    slidesPerView: "auto",
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

});